import escapeRegExp from 'lodash/escapeRegExp';
import { getDomainInfo, getOriginURLs, } from '@tribeplatform/react-components/common';
export const parseHref = (href, networkPublicInfo) => {
    const { subfolder, domain } = getDomainInfo(networkPublicInfo);
    if (!href) {
        return '';
    }
    const originURLs = getOriginURLs(networkPublicInfo === null || networkPublicInfo === void 0 ? void 0 : networkPublicInfo.domain, domain, subfolder);
    const hrefWithProtocol = addProtocol(href);
    const hrefWithoutOriginURLs = removeOriginURLs(hrefWithProtocol, originURLs);
    return hrefWithoutOriginURLs;
};
export const getLinkRel = (target, isTrusted) => {
    const isBlank = target === '_blank';
    const blankRel = isBlank ? 'noopener noreferrer' : '';
    const trustRel = !isTrusted ? 'nofollow ugc' : '';
    const linkRel = `${blankRel} ${trustRel}`;
    return linkRel.trim();
};
export const getLinkFeatures = (target) => {
    const isBlank = target === '_blank';
    if (isBlank) {
        return 'noopener,noreferrer';
    }
    return '';
};
export const getIsInternal = (href) => {
    if (href.indexOf('?') === 0) {
        return true;
    }
    if (href.indexOf('#') === 0) {
        return true;
    }
    if (href.indexOf('/') === 0 && href.indexOf('//') !== 0) {
        return true;
    }
    return false;
};
export const getLinkTarget = (target, isInternal) => {
    if (!target) {
        return isInternal ? '' : '_blank';
    }
    return target;
};
const addProtocol = (href) => {
    const isInternal = getIsInternal(href);
    if (isInternal) {
        return href;
    }
    const protocolRegExp = new RegExp('^(http(s)?:\\/\\/|\\/\\/|mailto:|tel:|#)');
    if (protocolRegExp.test(href)) {
        return href;
    }
    return `https://${href}`;
};
const removeOriginURLs = (href, originURLs) => {
    const escapedOriginURLs = originURLs.map(url => escapeRegExp(url));
    const hrefWithoutOriginURLs = href.replace(new RegExp(`^(http(s)?:\\/\\/|\\/\\/)(${escapedOriginURLs.join('|')})`), '');
    return hrefWithoutOriginURLs || '/';
};
//# sourceMappingURL=index.js.map